import { createAction, handleActions } from 'redux-actions'

const startFetching = createAction('MODULES/VALUATION_SERVICES_POPOVER/START_FETCHING')
const finishFetching = createAction('MODULES/VALUATION_SERVICES_POPOVER/FINISH_FETCHING')

const defaultState = false

const reducer = handleActions(
  {
    [startFetching]: () => true,
    [finishFetching]: () => false,
  },
  defaultState,
)

export { startFetching, finishFetching, reducer }
